import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HumanCapitalConfigurationSectionActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/Section/SectionBrowser")
	}

	render() {
		return (
			<Activity 
				name="HumanCapitalConfigurationSection"
				RenderedComponent={this.RenderedComponent}
				context="HumanCapitalConfigurationSection"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HumanCapitalConfigurationSectionActivity)
